import styled from 'styled-components';

import { Text } from '../../../../components';
import { InputRow, Input as FieldInput } from '../../../../components/Field/Field.styles';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export { Root, Label } from '../../../../components/Field/Field.styles';

/** The Field's input box, wrapping so the chips and the input share it. */
export const ChipsRow = styled(InputRow)`
  flex-wrap: wrap;
  gap: ${SPACE[8]};
  padding: ${SPACE[8]} ${SPACE[12]};
  min-height: 52px;
`;

export const Chips = styled.ul`
  display: contents;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Chip = styled.li<{ $inherited: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: ${SPACE[4]} ${SPACE[8]} ${SPACE[4]} ${SPACE[12]};
  border-radius: 99px;
  font-size: 14px;
  border: 1px ${(p) => (p.$inherited ? 'dashed' : 'solid')} ${COLORS.panelBorder};
  background: ${(p) => (p.$inherited ? 'transparent' : COLORS.surfaceSoft)};
  color: ${(p) => (p.$inherited ? COLORS.textFaint : COLORS.text)};
  ${(p) => (p.$inherited ? `padding-right: ${SPACE[12]};` : '')}
`;

export const ChipLabel = styled(Text)`
  line-height: 1.2;
  overflow-wrap: anywhere;
`;

export const FocusMark = styled(Text)`
  flex: 0 0 auto;
  padding: 1px 6px;
  border-radius: 99px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${COLORS.ctaTint};
  color: ${COLORS.accent};
`;

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACE[2]};
  border: none;
  border-radius: 99px;
  background: transparent;
  color: ${COLORS.textMuted};
  cursor: pointer;
  transition: color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
  &:hover,
  &:focus-visible {
    color: ${COLORS.text};
  }
`;

export const Input = styled(FieldInput)`
  flex: 1 1 120px;
  padding: ${SPACE[4]} 0;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const Hint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;
